import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import debounce from 'lodash/debounce';
import { useEffect } from 'react';

import { Icon } from 'apps/shared/scripts/components';
import { Breakpoints } from 'apps/shared/scripts/styles/constants';

import { iconClassName, mobileMenuClassName } from './styles';

interface Props {
  isMenuVisible?: boolean;
  onToggle: () => void;
}

const MobileMenu = ({ isMenuVisible, onToggle }: Props) => {
  useEffect(() => {
    // Prevent body scrolling while mobile menu is open
    if (isMenuVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  }, [isMenuVisible]);

  useEffect(() => {
    const handleResize = debounce(() => {
      if (window.innerWidth >= Breakpoints.MD) {
        document.body.style.removeProperty('overflow');
      } else {
        document.body.style.overflow = 'hidden';
      }
    }, 250);

    if (isMenuVisible) {
      window.addEventListener('resize', handleResize);
      handleResize();
    }

    return () => {
      handleResize.cancel();
      window.removeEventListener('resize', handleResize);
    };
  }, [isMenuVisible]);

  return (
    <div className={mobileMenuClassName} onClick={onToggle} role="button">
      <Icon className={iconClassName} fa={isMenuVisible ? faTimes : faBars} />
    </div>
  );
};

MobileMenu.displayName = 'MobileMenu';

export default MobileMenu;
